import { Component } from "@angular/core";

@Component({
  selector: "app-auth-fail",
  templateUrl: "./auth-fail.component.html",
  styleUrl: "./auth-fail.component.scss",
  standalone: false
})
export class AuthFailComponent {}
